import FormContainer from '@/components/forms/FormContainer';
import { withDescription } from '@/se/components/Description';
import NumberInput from '@/se/components/inputs/NumberInput';
import ObjectInput from '@/se/components/inputs/ObjectInput';
import PhoneInput from '@/se/components/inputs/PhoneInput';
import SelectInput from '@/se/components/inputs/SelectInput';
import TextInput from '@/se/components/inputs/TextInput';
import { withLabel } from '@/se/components/Label';
import { CompensationLabel, EmploymentLabel } from '@/types/StaffMember';
import { formatProviderId } from '@/util/providerId';
import React from 'react';
import { compose, mapProps, withProps } from 'recompose';
import BraceletIdInput from '../BraceletIdInput';
import OtherSpecialtiesSelectInput from './OtherSpecialtiesSelectInput';
import PrimarySpecialtySelectInput from './PrimarySpecialtySelectInput';
import TitleSelectInput from './TitleSelectInput';
import { useStaffCostAccess } from '@/hooks/useStaffCostAccess';

const StaffMemberInput = withProps({
  schema: {
    firstName: compose(
      withLabel('First Name'),
      withProps({
        placeholder: 'e.g., Martha',
        autoComplete: 'off',
        required: true,
      })
    )(TextInput),
    lastName: compose(
      withLabel('Last Name'),
      withProps({
        placeholder: 'e.g., Jane',
        autoComplete: 'off',
        required: true,
      })
    )(TextInput),
    braceletId: withProps({ nonPatient: true })(BraceletIdInput),
    hstId: compose(
      withLabel('Provider ID'),
      withProps({
        placeholder: 'e.g., 182',
        autoComplete: 'off',
        required: false,
      }),
      mapProps(({ value, onChange, ...rest }) => ({
        value: formatProviderId(value),
        onChange: next => onChange('l/' + next),
        ...rest,
      }))
    )(NumberInput),
    phoneNumber: compose(
      withLabel('Phone Number'),
      withDescription('This phone number will be used for schedule sharing.'),
      withProps({
        placeholder: 'Enter mobile phone number',
        autoComplete: 'off',
      })
    )(PhoneInput),
    email: compose(
      withLabel('Email'),
      withProps({
        placeholder: 'e.g., john@clinic.edu',
        autoComplete: 'off',
        type: 'email',
        required: false,
      })
    )(TextInput),
    primarySpecialty: PrimarySpecialtySelectInput,
    otherSpecialties: OtherSpecialtiesSelectInput,
    title: TitleSelectInput,
    employment: compose(
      withLabel('Employment'),
      withProps({
        options: EmploymentLabel,
        placeholder: 'e.g., Full Time',
        required: false,
      })
    )(SelectInput),
    compensation: compose(
      withLabel('Compensation'),
      withProps({
        options: CompensationLabel,
        placeholder: 'e.g., Hourly',
        required: false,
      })
    )(SelectInput),
    hourlyRate: compose(
      withLabel('Hourly Rate'),
      withProps({
        autoComplete: 'off',
        required: false,
      })
    )(NumberInput),
  },
  render: ({
    firstName,
    lastName,
    braceletId,
    hstId,
    phoneNumber,
    email,
    primarySpecialty,
    otherSpecialties,
    title,
    employment,
    compensation,
    hourlyRate,
  }) => {
    const hasStaffCostAccess = useStaffCostAccess();

    return (
      <FormContainer>
        {firstName}
        {lastName}
        {braceletId}
        {hstId}
        {phoneNumber}
        {email}
        {primarySpecialty}
        {otherSpecialties}
        {title}
        {employment}
        {compensation}
        {hasStaffCostAccess && hourlyRate}
      </FormContainer>
    );
  },
})(ObjectInput);

export default StaffMemberInput;
